import { usePlayer } from "@packages/media";

export const useMediaAnalyticsProps = ({
  screen = "track_settings",
}: { screen?: string } = {}) => {
  const player = usePlayer();

  return {
    screen_name: screen,
    ...(player?.analyticsProps ?? {}),
  };
};
